var _script, _g, _defs, _script2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: ""
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_159_2224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5 14C28.5 21.732 22.232 28 14.5 28C6.76801 28 0.5 21.732 0.5 14C0.5 6.26801 6.76801 0 14.5 0C22.232 0 28.5 6.26801 28.5 14ZM15.0017 10.3354C13.64 10.9018 10.9185 12.0741 6.83721 13.8522C6.17447 14.1158 5.8273 14.3736 5.7957 14.6257C5.74228 15.0517 6.27583 15.2195 7.00238 15.448C7.10121 15.4791 7.20361 15.5113 7.30859 15.5454C8.02341 15.7777 8.98496 16.0496 9.48484 16.0604C9.93827 16.0702 10.4443 15.8832 11.0031 15.4996C14.8164 12.9255 16.7848 11.6244 16.9084 11.5964C16.9955 11.5766 17.1164 11.5517 17.1982 11.6245C17.2801 11.6972 17.272 11.835 17.2634 11.872C17.2105 12.0973 15.1161 14.0444 14.0323 15.0521C13.6944 15.3662 13.4548 15.589 13.4058 15.6399C13.296 15.7539 13.1841 15.8617 13.0766 15.9654C12.4126 16.6055 11.9146 17.0856 13.1042 17.8696C13.6759 18.2463 14.1334 18.5579 14.5898 18.8687C15.0882 19.2081 15.5853 19.5466 16.2285 19.9683C16.3924 20.0757 16.5489 20.1873 16.7014 20.2959C17.2814 20.7095 17.8025 21.081 18.4464 21.0217C18.8204 20.9873 19.2069 20.6355 19.4031 19.5864C19.8669 17.107 20.7786 11.7349 20.9893 9.52114C21.0077 9.32718 20.9845 9.07897 20.9658 8.97C20.9472 8.86104 20.9082 8.70579 20.7666 8.59087C20.5989 8.45476 20.3399 8.42606 20.2241 8.4281C19.6975 8.43737 18.8896 8.71829 15.0017 10.3354Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_159_2224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.5)"
  })))), _script2 || (_script2 = /*#__PURE__*/React.createElement("script", {
    xmlns: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.77211783c820c8ec2ca08925f7f4c6bd.svg";
export { ForwardRef as ReactComponent };